import React from 'react'

const tooltipRefs = {
    tooltipRef: React.createRef(),
}

export function getTooltipRef() {
    return tooltipRefs.tooltipRef
}
